import { render, staticRenderFns } from "./Papers_Recored.vue?vue&type=template&id=2bcf4d0c&"
import script from "./Papers_Recored.vue?vue&type=script&lang=js&"
export * from "./Papers_Recored.vue?vue&type=script&lang=js&"
import style0 from "./Papers_Recored.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports